// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupBorder {
    border: 1px solid lightgray;
    border-radius: 4px;
    margin-bottom: 4px;
    padding: 2px;
}

.colorPreview {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    margin: 0px 4px;
}

.annotationSeries {
    margin: 0px 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/menutabs/charts/charts.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".groupBorder {\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    margin-bottom: 4px;\n    padding: 2px;\n}\n\n.colorPreview {\n    height: 24px;\n    width: 24px;\n    border-radius: 4px;\n    margin: 0px 4px;\n}\n\n.annotationSeries {\n    margin: 0px 24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
